// Injectable file-URL builder. The client portal uses the page-URL token
// (api.fileUrl, the default); the admin dashboard provides a builder bound to a
// specific collection's share token. This is the ONLY token-coupled primitive in
// the shared render tree (FileRow / Preview / Questions), so injecting it here
// lets the admin reuse those components with ZERO change to client behaviour.
import { createContext, useContext } from 'react'
import { fileUrl } from '../lib/api'

export const FileUrlContext = createContext<(id: string) => string>(fileUrl)
export const useFileUrl = () => useContext(FileUrlContext)
